<template>
  <v-row>
    <v-col cols="12" NewEditDeleteDialog>
      <v-dialog v-model="dialog" persistent max-width="1000">
        <v-card :loading="loading" v-if="!deleting">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{ newResource.id ? i18n.edit : i18n.add }}</span></div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="4" class="py-0" v-for="(field, k) in resourceKeys" :key="'key-' + k">
                <v-text-field
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  outlined
                  :readonly="field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly"
                  :disabled="field.name != 'email' ? field.readonly : field.name == 'email' && newResource.match_sub && newResource.match_sub.bounced ? false : field.readonly"
                  v-if="field.type == 'text' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                  dense
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model="newResource[field.name]"
                >
                  <template v-slot:append-outer v-if="field.info && field.info[language]">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
                      </template>
                      <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                        {{field.info.en}}
                      </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-textarea
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  outlined
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  v-if="field.type == 'textarea' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                  dense
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model="newResource[field.name]"
                >
                  <template v-slot:append-outer v-if="field.info && field.info[language]">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
                      </template>
                      <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                        {{field.info.en}}
                      </span>
                    </v-tooltip>
                  </template>
                </v-textarea>
                <v-text-field
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  outlined
                  v-if="field.type == 'number' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  autocomplete="disabled"
                  :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                  dense
                  @keypress="isNumber($event)"
                  :class="`${arabic?'arFont':'enFont'}`"
                  v-model="newResource[field.name]"
                >
                  <template v-slot:append-outer v-if="field.info && field.info[language]">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
                      </template>
                      <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                        {{field.info.en}}
                      </span>
                    </v-tooltip>
                  </template>
                </v-text-field>
                <v-autocomplete
                  :items="field.data"
                  v-model="newResource[field.name]"
                  :label="i18n[field.label]"
                  :name="getNameID()"
                  :id="getNameID()"
                  clearable
                  :multiple="field.multiple"
                  autocomplete="disabled"
                  :rules="[ field.required ? rules.required : false]"
                  v-if="field.type == 'select' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  outlined
                  dense
                  :item-value="`${field.name}_id`"
                  :class="`${arabic?'arFont':'enFont'}`"
                >
                  <template v-slot:append-outer v-if="field.info && field.info[language]">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
                      </template>
                      <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                        {{field.info.en}}
                      </span>
                    </v-tooltip>
                  </template>
                </v-autocomplete>
                <v-switch 
                  v-if="field.type == 'switch' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  :name="getNameID()"
                  :id="getNameID()"
                  :class="`${arabic?'arFont':'enFont'}`" 
                  :label="i18n[field.label]" 
                  :readonly="field.readonly"
                  :disabled="field.readonly"
                  color="primary"
                  dense
                  :hint="`${field.info && field.info[language] ? field.info.en : ''}`"
                  :persistent-hint="field.info && field.info[language] ? true : false"
                  v-model="newResource[field.name]"
                >
                  
                </v-switch>
                <v-menu
                  v-model="datepicker[field.name]"
                  :close-on-content-click="false"
                  v-if="field.type == 'date' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
                >
                  
                  <template v-slot:activator="{ on, attrs }">
                    <v-text-field
                      :label="i18n[field.label]"
                      :name="getNameID()"
                      :id="getNameID()"
                      outlined
                      :disabled="field.readonly"
                      v-if="field.type == 'date' && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                      autocomplete="disabled"
                      :rules="[field.required ? rules.required : false, field.email ? rules.email : false]"
                      dense
                      :class="`${arabic?'arFont':'enFont'}`"
                      v-model="newResource[field.name]"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                    >
                      <template v-slot:append-outer v-if="field.info && field.info[language]">
                        <v-tooltip top>
                          <template v-slot:activator="{ on, attrs }">
                            <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
                          </template>
                          <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                            {{field.info.en}}
                          </span>
                        </v-tooltip>
                      </template>
                    </v-text-field>
                  </template>
                  <v-date-picker
                    v-model="newResource[field.name]"
                    @input="datepicker[field.name] = false"
                  ></v-date-picker>
                </v-menu>
                <vue-editor 
                  ref="editorV" 
                  v-if="field.type == 'editor' 
                  && (!field.conditions || !field.conditions.map(x=>x.con).includes('display') 
                  || newResource[field.conditions.filter(x=>x.con == 'display')[0].con_field] 
                  == field.conditions.filter(x=>x.con == 'display')[0].con_val)"
                  v-model="newResource[field.name]">
                </vue-editor>
                <v-text-field
                  :label="i18n[field.label]"
                  :readonly="true"
                  v-if="field.type == 'upload'"
                  autocomplete="disabled"
                  dense
                  outlined
                  :loading="uploadProgress"
                  @click="pickFileImages(field.name)"
                  v-model.trim="newResource[field.name]"
                >
                  <template v-slot:append-outer v-if="field.info && field.info[language]">
                    <v-tooltip top>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon size="18" color="primary" left v-bind="attrs" v-on="on" >help</v-icon>
                      </template>
                      <span :class="`${arabic?'arFont':'enFont'} pa-0`">
                        {{field.info.en}}
                      </span>
                    </v-tooltip>
                  </template>
                  <template v-slot:prepend>
                    <v-tooltip top>
                      <template v-slot:activator="{ on }">
                        <v-btn small color="primary" :loading="uploadProgress" icon @click="pickFileImages(field.name)" v-on="on">
                          <v-icon>
                            cloud
                          </v-icon>
                        </v-btn>
                      </template>
                      {{field.info.en}}
                      <input
                        type="file"
                        style="display: none"
                        ref="fileImages"
                        accept="csv/*"
                        @change="onFilePickedImages"
                        v-if="field.type == 'upload'"
                      >
                    </v-tooltip>
                  </template>
                </v-text-field>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" text @click.native="closeDialog()" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
            <v-btn 
              color="success" 
              v-if="!newResource.id"
              :disabled="!validate(newResource)"
              text @click.native="postResource(newResource)" 
              :class="`${arabic?'arFont':'enFont'}`"
            >{{i18n.submitBtn}}</v-btn>
            <v-btn 
                color="success" 
                v-if="newResource.id"
                :disabled="!validate(newResource)"
                text @click.native="updateResource(newResource)" 
                :class="`${arabic?'arFont':'enFont'}`"
              >{{i18n.updateBtn}}</v-btn>
          </v-card-actions>
        </v-card>
        <v-card :loading="loading" v-if="deleting">
          <v-card-title :class="`${arabic?'arFont':'enFont'} font-weight-bold`" style="font-size:22px;">
            <div>{{ i18n[resourceSettings.resourceName]  + ' | ' }}<span class="font-weight-light">{{i18n.delete}}</span></div>
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12" md="12" class="pa-5 error white--text" :class="`${arabic ? 'arFont' : 'enFont'}`">
                {{i18n.areYouSureOfDelete.replace('|item|', deleteResrouceName )}}
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="success" text @click.native="closeDialog()" :class="`${arabic?'arFont':'enFont'}`">{{i18n.cancelBtn}}</v-btn>
            <v-btn 
                color="error" 
                v-if="newResource.id"
                text @click.native="deleteResource(newResource)" 
                :class="`${arabic?'arFont':'enFont'}`"
              >{{i18n.deleteBtn}}</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-col>
  </v-row>
</template>

<script>
import { VueEditor } from "vue2-editor";
import { getRandomInt, randomString, getCDate, check, sleep } from '@/customFunction';
import { firebase, store, db, auth, storageRef } from '@/fb';

export default {
  components: {
    VueEditor
  },
  props:['dialog', 'deleting', 'resourceKeys', 'newResource', 'loading', 'resourceSettings'],
  data(){
    return {
      rules: {
        required: value => !!value || this.i18n['required'],
        email: value => /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(value) || this.i18n['valid_email']
      },
      datepicker:{},
      timepicker:{},
      menu:{},
      uploadProgress:null,
      uploadFiled:null,
      file:null,

    }
  },
  methods: {
    getNameID(){
      return randomString(24, '#Aa') + `${new Date().getTime()}`
    },
    validate(newResource, notify) {
      let fsr = this.resourceKeys.filter(x=>x.required)
      let fse = this.resourceKeys.filter(x=>x.email)
      let v = true
      fsr.forEach(x=>{
        if(!newResource[x.name]) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.required}`, 'error')
        }
      })
      fse.forEach(x=>{
        if(!/^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(newResource[x.name])) {
          v = false
          if(notify)
          this.$emit('snackbarNotification', `${this.i18n[x.name]} ${this.i18n.valid_email}`, 'error')
        }
      })
      return v
    },
    isNumber(evt) {
      evt = (evt) ? evt : window.event;
      var charCode = (evt.which) ? evt.which : evt.keyCode;
      if (charCode != 46 && charCode != 45 && charCode != 46 &&
      !(charCode >= 48 && charCode <= 57)) {
        evt.preventDefault();;
      } else {
        return true;
      }
    },
    goTo(path) {
      this.$router.push(path).catch(x=>{})
    },
    closeDialog() {
      this.$emit('closeDialog')
    },
    deleteResource(newResource) {
      this.$emit('deleteResource', newResource)
    },
    updateResource(newResource) {
      this.$emit('updateResource', newResource)
    },
    postResource(newResource) {
      this.$emit('postResource', newResource)
    },
    pickFileImages(name){
      // console.log(this.$refs)
      this.uploadFiled = name
      this.$refs.fileImages[0].click()
    },
    loadFileImages(file, type, ext){
      var file = file
      var metadata = {
        contentType: type
      };
      var uploadTask = storageRef.child('images/J_B_E_' + randomString(16, 'Aa#') + '.' + ext).put(file, metadata);
      uploadTask.on(firebase.storage.TaskEvent.STATE_CHANGED, // or 'state_changed'
        (snapshot)=> {
          var progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
					  this.uploadProgress = true
          }, (error) =>{
          // console.log(error);

        switch (error.code) {

          case 'storage/unauthorized':
            break;
          case 'storage/canceled':
            break;
          case 'storage/unknown':
            break;
        }
      },() => {
        uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) =>{
					this.uploadProgress = false
          this.$emit('getUpload', {field:this.uploadFiled, value:downloadURL} )
          // console.log(downloadURL)
        });
      });
    },
    onFilePickedImages (e) {
      const files = e.target.files
      if(files[0] !== undefined) {
        const fr = new FileReader ()
        fr.readAsDataURL(files[0])
        fr.addEventListener('load', () => {
          this.file = files[0] // this is an image file that can be sent to server...
          this.loadFileImages(this.file, this.file.type, this.file.name.split('.').pop())
        })
      } 
    },
  },
  computed:{
    deleteResrouceName() {
      if (this.newResource.name) return this.newResource.name

      if (this.newResource.label) return this.newResource.label

      return ''
    },
    api(){
      return this.$store.state.settings.apiBase
    },
    language(){
      return this.$store.state.language
    },
    i18n(){
      return this.$store.state.i18n[this.$store.state.language]
    },
    arabic(){
      if(this.$store.state.language == 'ar') return true
    },
  },
  mounted(){
    
  }
}
</script>

<style>

</style>